import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {SearchHandlerService} from '../../search-handler.service';
import {FocusServiceImplementation, SearchFocusService} from '../../search-focus.service';
import {SearchExecutorService} from '../../search-executor.service';
import {SearchContainer} from '../../../core/definitions/search-container';

@Component({
  selector: 'app-search-filter-menu-path',
  templateUrl: './search-filter-menu-path.component.html',
  styleUrls: ['./search-filter-menu-path.component.scss']
})
export class SearchFilterMenuPathComponent implements OnInit, OnDestroy {

  @Input() searchContainer: SearchContainer;
  @Input() sideMenu;

  searchMenuPath = [];
  private fsi: FocusServiceImplementation;

  constructor(private searchExecutorService: SearchExecutorService,
              private searchHandler: SearchHandlerService,
              private searchFocusService: SearchFocusService) {
  }

  ngOnInit() {
    this.searchExecutorService.subscribeToSearchResult(this.searchContainer, this.setSearchMenuPath);
  }

  ngOnDestroy(): void {
    this.searchExecutorService.unSubscribeToSearchResult(this.searchContainer, this.setSearchMenuPath);
  }

  goToMenuPath(menuPath) {
    if (this.searchContainer.focus.curFocus) {
      this.fsi = this.searchFocusService.createFSI(this.searchContainer);
      const exists = this.searchFocusService.checkPathParamsExists(menuPath.path, this.searchContainer);
      if (!exists) {
        this.fsi.setCurrentFocus(null);
      }
    }
    this.searchContainer.objectCount = 0;
    this.searchContainer.targetId = menuPath.targetId;
    this.searchContainer.path = menuPath.path;
    this.searchContainer.breadcrumbs = [];
    this.searchHandler.goPathView(menuPath.path, this.searchContainer).then();
  }


  private setSearchMenuPath = () => {
    const path = this.searchHandler.getSearchMenuPath(this.searchContainer);
    if (path) {
      this.searchMenuPath = path;
    }
  }

}
